export const API_URL =
	process.env.NODE_ENV === 'production'
		? 'https://feedback.dominos.com.br/api/'
		// : 'https://feedback.dominos.com.br/api/';
		// : 'http://localhost:8000/api/';
		// : "http://feeedback-hml.dominos.com.br/api/"
		: 'https://feedback.dominos.com.br/api/'

export const SURVEY_ALREADY_ANSWERED = 3;
export const OFFLINE_SURVEY_URL = '/pesquisa-de-satisfacao/offline';
export const SURVEY_ALREADY_DONE =
	'/pesquisa-de-satisfacao/pesquisa-finalizada';
export const TOKEN_DOESNT_EXIST = null;
export const STORAGE_STEP = 'Step';
export const STORAGE_ANSWER = 'Answers';
export const PUBLIC_SURVEY = true;
export const PRIVATE = 1;
export const PUBLIC = 2;
